import { FC } from 'react';
import styled from 'styled-components';

import { useI18nValues } from '@/entities/vfo/hooks/useI18nValues';
import { TaskStatus } from '@/entities/vfo/types';

import { Select } from '../uikit/Select';

type SelectStatusProps = {
  value: TaskStatus;
  onChange: (value: TaskStatus) => void;
};

export const SelectStatus: FC<SelectStatusProps> = ({ value, onChange }) => {
  const { status } = useI18nValues();

  return (
    <SelectStyled
      options={[
        {
          label: status(TaskStatus.TODO),
          value: TaskStatus.TODO,
        },
        {
          label: status(TaskStatus.IN_PROGRESS),
          value: TaskStatus.IN_PROGRESS,
        },
        {
          label: status(TaskStatus.DONE),
          value: TaskStatus.DONE,
        },
      ]}
      value={value}
      dropdownStyle={{
        minWidth: 130,
      }}
      onChange={onChange}
    />
  );
};

const SelectStyled = styled(Select)`
  &&& {
    .ant-select-selector {
      border: none;
      background: none;
      outline: none;
      box-shadow: none !important;
    }
  }
`;
